/**
 * UI strings for universal components.
 * Centralised locale constants for the admin panel.
 */
export const UI_STRINGS = {
  // Common
  yes: 'Да',
  no: 'Нет',
  cancel: 'Отмена',
  save: 'Сохранить',
  loading: 'Загрузка...',
  all: 'Все',
  clear: 'Очистить',
  reset: 'Сбросить',
  apply: 'Применить',
  from: 'От',
  to: 'До',

  // CRUD actions
  edit: 'Редактировать',
  delete: 'Удалить',
  restore: 'Восстановить',
  deletePermanently: 'Удалить навсегда',
  deleting: 'Удаление...',

  // Table
  create: (label: string) => `Создать ${label}`,
  search: (label: string) => `Поиск по ${label}...`,
  filters: (count: number) => count > 0 ? `Фильтры (${count})` : 'Фильтры',
  showDeleted: 'Показать удалённые',
  hideDeleted: 'Скрыть удалённые',
  noData: (label: string) => `Нет ${label}`,
  openActionsMenu: 'Открыть меню действий',

  // Duration - placeholder functions to be replaced with pluralize in UniversalTable
  durationYears: (n: number) => `${n} лет`,
  durationMonths: (n: number) => `${n} мес.`,
  durationWeeks: (n: number) => `${n} нед.`,
  durationDays: (n: number) => `${n} дн.`,

  // Show page
  notFound: 'Запись не найдена',
  error: 'Ошибка загрузки',
  errorUnknown: 'Неизвестная ошибка при загрузке записи',
  backToList: 'Вернуться к списку',
  deleted: 'Удалён',
  metadata: 'Метаданные',
  createdAt: 'Создан',
  updatedAt: 'Обновлён',
  deletedAt: 'Удалён',

  // Bulk actions
  selected: (count: number) => `Выбрано: ${count}`,
  clearSelection: 'Снять выделение',

  // Filters
  selectPlaceholder: (label: string) => `Выберите ${label}`,
  searchByField: (label: string) => `Поиск по ${label}`,

  // Soft delete dialog
  archiveEntity: (label: string) => `Архивировать ${label}`,
  deleteForever: (label: string) => `Удалить ${label} навсегда`,
  permanentWarningPrefix: 'Это действие',
  permanentWarning: 'необратимо',
  permanentDescription: (label: string) =>
    `${label} будет удалён из базы данных без возможности восстановления.`,
  confirmNamePrompt: 'Для подтверждения введите',
  archiveDescription: (label: string) =>
    `${label} будет перемещён в архив. Его можно будет восстановить позже.`,
  archive: 'Архивировать',

  // Language tabs
  filled: 'Заполнено',
} as const;
